<script lang="ts">
	import choiceImageXs from "@assets/images/fathers-family-choice.jpg?webp&h=480&imagetools";
	import choiceImageSm from "@assets/images/fathers-family-choice.jpg?webp&h=640&imagetools";
	import choiceImageLg from "@assets/images/fathers-family-choice.jpg?webp&h=800&imagetools";
	import choiceImage2xl from "@assets/images/fathers-family-choice.jpg?webp&imagetools";
	import BuildYourSubscriptionButton from "@components/BuildYourSubscriptionButton.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Media from "@components/common/Media.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import AboutUsContentSection from "./AboutUsContentSection.svelte";
	import translations from "./FathersChoiceSection.translations.json" with { type: "json" };

	const translate = getTranslate(translations);
</script>

<AboutUsContentSection imageLeft mediaClass="xl:w-150 xl:h-192">
	{#snippet heading()}
		<div class="flex flex-col">
			<div class="uppercase text-fcrorange font-bold tracking-[.1em]">
				<Formatted text={translate("section")} />
			</div>
			<Heading level={2} text={translate("title")} class="heading-2 text-fcrdarkgray mt-4" />
		</div>
	{/snippet}
	<div class="flex flex-col h-full gap-8 lg:gap-16 xl:gap-18 2xl:gap-24">
		<div class="space-y-4">
			<p class="text-5/tighter mt-4">
				<Formatted text={translate("paragraph")} />
			</p>
			<p class="text-5/tighter">
				<Formatted text={translate("variantsParagraph")} />
			</p>
		</div>
		<p class="font-antipol font-medium sm:text-8/tighter text-fcrdarkgray mt-10 sm:mt-14 xl:mt-auto">
			<Formatted text={translate("tagline")} />
		</p>
	</div>
	{#snippet media()}
		<div class="absolute inset-0 flex flex-col justify-end items-center pb-8 sm:pb-12">
			<Media
				width={300}
				height={480}
				source={{ type: "image/webp", src: choiceImageXs }}
				sourcesets={{
					">sm": choiceImageSm,
					">lg": choiceImageLg,
					">2xl": choiceImage2xl,
				}}
				alt=""
				class="size-full object-cover object-top"
				wrapperClass="absolute inset-0"
			/>
			<BuildYourSubscriptionButton variant={ButtonVariant.White} registerLabel />
		</div>
	{/snippet}
</AboutUsContentSection>
